export default __webpack_public_path__ + "static/media/me2.35ec09e0.jpg";